import { BadgeProps, Badge as CssModulesBadge } from '@sunwebgroup/uds-ui/badge'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/badge' instead.
 */
export default Object.assign(
  styled(CssModulesBadge)<BadgeProps>``,
  { displayName: 'Badge' },
)
